import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInformationService } from '../app-information.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class UtilityService {
    static serviceName: string;

    constructor(private http: HttpClient, private appInfo: AppInformationService) {
        UtilityService.serviceName = environment.apiUrl;
    }

    async getServiceVersion() {
        const result = await this.http.post(`${UtilityService.serviceName}/utility/getServiceVersion`, {}).toPromise();
        return result;
    }

    async getNextJobNumber() {
        // const result = await this.http.post(`${UtilityService.serviceName}/utility/getActiveFlockByCoopId`,  {coopId} ).toPromise();
        const result = await this.http.post(`${UtilityService.serviceName}/utility/getNextJobNumber`, {}).toPromise();
        return result;
    }

    async getNextInvoiceNumber() {
        const result = await this.http.post(`${UtilityService.serviceName}/utility/getNextInvoiceNumber`, {}).toPromise();
        return result;
    }

    async emailReport(emailId: number) {
        console.log(emailId);
        const result = await this.http.post(`${UtilityService.serviceName}/utility/emailReport`, emailId).toPromise();
        return result;
    }
}
